import { Instagram, Mail, MessageCircle } from "lucide-react";
import { PROFILE } from "../data/cv";
import { scrollToId } from "./Nav";

const LINKS = [
  ["Profile", "#about"],
  ["Ventures", "#ventures"],
  ["Experience", "#experience"],
  ["Research", "#research"],
  ["Engage", "#engage"],
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/[0.07] py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
          <div>
            <p className="font-display font-bold text-lg tracking-tight">
              Dr. Rahul Kanungo<span className="text-neon">.</span>
            </p>
            <p className="mt-2 text-sm text-slate-500 max-w-xs">
              Consultant pathologist × Applied AI — building the systems modern healthcare deserves.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href={PROFILE.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" aria-label="Instagram" className="grid place-items-center w-10 h-10 rounded-full border border-white/10 text-slate-400 hover:text-fuchsia-300 hover:border-fuchsia-400/50 transition-colors duration-300">
                <Instagram size={16} />
              </a>
              <a href={`mailto:${PROFILE.email}`} data-testid="footer-email-link" aria-label="Email" className="grid place-items-center w-10 h-10 rounded-full border border-white/10 text-slate-400 hover:text-neon hover:border-neon/50 transition-colors duration-300">
                <Mail size={16} />
              </a>
              <a href={PROFILE.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" aria-label="WhatsApp" className="grid place-items-center w-10 h-10 rounded-full border border-white/10 text-slate-400 hover:text-emerald-400 hover:border-emerald-400/50 transition-colors duration-300">
                <MessageCircle size={16} />
              </a>
            </div>
          </div>

          <nav className="grid grid-cols-2 gap-x-12 gap-y-3">
            {LINKS.map(([label, href]) => (
              <button key={href} data-testid={`footer-link-${label.toLowerCase()}`} onClick={() => scrollToId(href)} className="text-left text-sm text-slate-500 hover:text-white transition-colors duration-300">
                {label}
              </button>
            ))}
          </nav>
        </div>

        <div className="mt-12 pt-6 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-600 font-mono">
          <p>© 2026 Dr. Rahul Kanungo · Bhubaneswar, Odisha, India</p>
          <p>Crafted with clinical precision &amp; applied AI</p>
        </div>
      </div>
    </footer>
  );
}